module.exports = __webpack_public_path__ + "img/year-digit.c47b5cbc.svg";